module.exports = __webpack_public_path__ + "img/branding-ar.c0496058.svg";